import { render, staticRenderFns } from "./MetadadosCampoDinamicoRadio.vue?vue&type=template&id=001529bf"
import script from "./MetadadosCampoDinamicoRadio.vue?vue&type=script&lang=js"
export * from "./MetadadosCampoDinamicoRadio.vue?vue&type=script&lang=js"
import style0 from "./MetadadosCampoDinamicoRadio.vue?vue&type=style&index=0&id=001529bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports